import { getEnvironment, Environment } from './'

export const LAUNCH_DARKLY_CLIENT_ID_PRODUCTION = '6227dd818f38cc14252b1dfd'
export const LAUNCH_DARKLY_CLIENT_ID_STAGING = '6227dd818f38cc14252b1dfc'

export const getLaunchdarklyClientId = () => {
	return getEnvironment() === Environment.PRODUCTION ? LAUNCH_DARKLY_CLIENT_ID_PRODUCTION : LAUNCH_DARKLY_CLIENT_ID_STAGING
}
